// @flow
// $FlowFixMe
import React from 'react';
import { Field } from '@8base-react/forms';
import { InputField, TextAreaField, Row, Column } from '@8base/boost';


import { requiredWithSpaces } from 'utils/formValidations';
import { WorkspaceImageInput } from 'common/components/WorkspaceImageInput';

type BasicInformationProps = {
  isOwner: boolean,
  e2eWorkspaceNameFieldProps: any,
  e2eWorkspaceDescriptionFieldProps: any,
  children: React$Node,
};

export const BasicInformation = ({
  isOwner,
  e2eWorkspaceNameFieldProps,
  e2eWorkspaceDescriptionFieldProps,
  children,
}: BasicInformationProps) => {
  return (
    <Row gap="lg" >
      <Column>
        <Field
          name="image"
          component={ WorkspaceImageInput }
          disabled={ !isOwner }
          size="xl"
        />
      </Column>
      <Column stretch gap="xl" >
        <Column stretch gap="lg" >
          <Field
            name="name"
            component={ InputField }
            validate={ requiredWithSpaces }
            label="Workspace Name"
            disabled={ !isOwner }
            { ...e2eWorkspaceNameFieldProps }
          />

          <Field
            name="description"
            component={ TextAreaField }
            label="Workspace Description"
            placeholder="Please tell us about your project"
            disabled={ !isOwner }
            { ...e2eWorkspaceDescriptionFieldProps }
          />

          { children }
        </Column>
      </Column>
    </Row>
  );
};
